
/**
 * @class
 * Interface of Loaders
 */
class Loader{
	hideLoader(){

	}
	showLoader(){

	}
	dispose(){
		
	}
}

/**
 * SpinLoader params
 * @typedef {Object} SPIN_OPTIONS
 * @property {string} id Box Loading Id.
 * @property {string} background CSS literal/rgb/rgba/hex/hls/hlsa box background.
 * @property {string} spinColor CSS literal/rgb/rgba/hex/hls/hlsa value.  Color for the static wheel.
 * @property {string} animationColor CSS literal/rgb/rgba/hex/hls/hlsa value. Color for the spinning wheel.
 * @property {string} center true for center the spin.
 * @property {string} width CSS spin width value.
 * @property {string} height CSS spin width value.
 * @property {string} position CSS box position.
 * @property {string} prefixAnimation prefix for the keyframes animation.
 * @property {string} ParentSelector Parent Selector where the Box is appended to.
 */

/**
* Spin Loader.
* @class
*/
class SpinLoader extends Loader{
	/**
	 * @constructor
	 * @param {SPIN_OPTIONS} spin Loader options.
	 */
	constructor(pOptions) {
		// Default options.
		super();
		let objOptions = {
			id: 'box_loader',
			background: 'rgba(255, 255, 255, 0.74)',
			spinColor: '#eee',
			animationColor: '#122566',
			center: true,
			width: '70px',
			height: '70px',
			position: 'fixed',
			prefixAnimation: 'SpinLoader',
			ParentSelector : 'body'
		}
		Object.assign(objOptions,pOptions);

		this.ID = objOptions.id;
		this.Background = objOptions.background;
		this.SpinColor = objOptions.spinColor;
		this.AnimationColor = objOptions.animationColor;
		this.Center = objOptions.center;
		this.Width = objOptions.width;
		this.Height = objOptions.height;
		this.Position = objOptions.position;
		this.PrefixAnimation = objOptions.prefixAnimation.trim();
		this.ParentSelector = objOptions.ParentSelector.trim();

		this.init();
	}
	/**  HTML box loader object.
		   @type {HTMLDivElement} 
		   @public
		   */
	get BoxLoader() {
		return this._boxLoader;
	}
	/**
	 * initialize box loading.
	 */
	init(){
		
		let objStyle = document.createElement('STYLE'),
			objDIVParent = document.createElement('DIV'),
			objDIVChild = document.createElement('DIV'),
			objContainer = document.querySelector(this.ParentSelector);
		
		//Build CSS animation
		objStyle.type = 'text/css';
		objStyle.innerText = `
			@keyframes ${this.PrefixAnimation}_AnimationSpinning { 
				from { transform: rotate(0deg); } 
				to {  transform: rotate(360deg); }  
			} 
			@keyframes ${this.PrefixAnimation}_AnimationFadeIn {  
				0% {opacity:0;} 100% {opacity:1;} 
			} 
			@keyframes ${this.PrefixAnimation}_AnimationFadeOut {  
				0% {opacity:1;} 100% {opacity:0;} 
			}`;
		//Build box
		objDIVParent.id = this.ID;
		objDIVParent.style.cssText = `
			position: ${this.Position};
			height: 100%;
			width: 100%;
			background: ${this.Background};
			z-index: 2147483647;
			top:0;
			left:0;
			display:none;
			`;
		//Build spin
		objDIVChild = document.createElement('DIV');
		objDIVChild.style.cssText = `
				position: ${this.Position};
				margin:auto;
				width: ${this.Width};
				height: ${this.Height};
				left:0;
				right:0;
				top:0;
				bottom:${this.Center ? '0' : '20%'};
				border: 10px solid ${this.SpinColor};
				border-top: 10px solid ${this.AnimationColor};
				border-radius: 50%;
				transform: translate(-50%, -50%);
				animation-name: Gspinning;
				animation:  ${this.PrefixAnimation}_AnimationSpinning 1s infinite;
							`;
		objDIVParent.appendChild(objStyle);
		objDIVParent.appendChild(objDIVChild);

		objDIVParent.addEventListener("animationend", (evt) => {
			if (evt.animationName === `${this.PrefixAnimation}_AnimationFadeOut`) {
				objDIVParent.style.display = "none";
				this.dispose();
			}
		}, false);

		// set Box Loader
		if (!!objContainer) {
			objContainer.appendChild(objDIVParent);
			this._boxLoader = objDIVParent;
		}
		else
		{
			throw new Error('Loader was not appended to parent Selector:' + this.ParentSelector);
		}
	}
	/**
	 * Display Box Loader object.
	 * @public
	 * @param {string} pValue Display CSS style
	 */
	displayBoxLoader(pSecondsInterval, pCSSValue) {
		if (pCSSValue == 'none') {
			this.BoxLoader.style.animation = `${this.PrefixAnimation}_AnimationFadeOut ${pSecondsInterval}s linear`;
		}
		else {
			this.BoxLoader.style.animation = `${this.PrefixAnimation}_AnimationFadeIn ${pSecondsInterval}s linear`;
			this.BoxLoader.style.display = pCSSValue;
		}
	}
	/**
	 * Hide Box Loader.
	 * @public
	 */
	hideLoader(pSecondsInterval = 1, pCSSValue = 'none'){
		this.displayBoxLoader(pSecondsInterval, pCSSValue);
	}
	/**
	 * Show Box Loader.
	 * @public
	 */
	 showLoader(pSecondsInterval = 0.85, pCSSValue = 'block'){
		this.displayBoxLoader(pSecondsInterval, pCSSValue);
	}
	/**
	 * Destroy Loader.
	 */
	dispose(){
		this.BoxLoader.remove();
		this._boxLoader = null;
	}
}